<mat-slide-toggle
  color="primary"
  hideIcon="true"
  [checked]="value"
  [disabled]="disabled"
  [dir]="dir"
  [class]="class"
  (change)="onToggleChange.emit($event.checked)"
>
  <span>{{ label }}</span>
</mat-slide-toggle>
